import React from 'react';

import AccessTimeIcon from '@material-ui/icons/AccessTime';



class Comp extends React.Component {

	render() {
		return (
			<span style={{
        display:'inline-block',
        boxSizing:'border-box',
        background:'rgba(255, 255, 255, 1)',
        border:'1px solid #B86E00',
        borderRadius:'1.8em',
        color:'#B86E00',
        padding:'0.1em 0.6em',
        fontWeight:'normal',
        textShadow:'-1px 1px 0px rgba(255, 255, 255, 0.5)',
        margin:'2px',
      }}>
				<AccessTimeIcon style={{fontSize:'1.2em', display:'inline-flex' ,verticalAlign:'middle'}}/>
				<span style={{fontSize:'0.9em'}}>{this.props.text}</span>
			</span>
		)
	}
}

export default Comp;
